<template>
	<div>
		<breadcrumb :items="breadcrumbs"></breadcrumb>
		<v-container fill-height fluid>
			<v-card width="100%" class="mb-5" >
					<template>
						<v-tabs center-active class="tabs-pill" v-model="tab" height="50">
							<v-tab class="text-capitalize" >{{ $t('profile') }} </v-tab>
							<v-tab class="text-capitalize">{{ $t('password') }}</v-tab>
							<v-tab class="text-capitalize">{{ $t('otherSettings') }}</v-tab>
						</v-tabs>
					</template>
			</v-card>
			
			<v-card width="100%" class="mb-5" >
				<v-tabs-items v-model="tab">
					<v-tab-item>
						<profile-update></profile-update>
					</v-tab-item>
					<v-tab-item>
						<password-update></password-update>
					</v-tab-item>
					<v-tab-item>
						<language-update></language-update>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
			
		</v-container>
	</div>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import ProfileUpdate from "./ProfileUpdate.vue"
import PasswordUpdate from "./PasswordUpdate.vue"
import LanguageUpdate from "./LanguageUpdate.vue"
import ProfileService from "../../_services/ProfileService";
export default {
	components:{
		ProfileUpdate,
		PasswordUpdate,
		LanguageUpdate
	},
	created() {
		this.getProfileData();
	},
	data() {
		return {
			tab:0,
			breadcrumbs: [
				{
					text: this.$t('dashboard'),
					disabled: false,
					href: '/',
				},
				{
					text:this.$t('profile'),
					disabled: true,
					href: 'breadcrumbs_link_1',
				},
			],
			errors: { email: '', otp: ''},
			orgUser:{},
			user: {
				name: '',
				email: '',
				mobile: '',
				department: '',
				profilePicUrl: '',
				role: '',
				userName: '',
			},
			email: '',
			editEmail: false,
			canUpdateEmail: false,
			verifyEmail: false,
			preferedLanguageId: '',
			selectedLangs: [],
			showOtp:false,
			otp: ['','','','','',''],
		}
	},
	methods: {
		getProfileData() {
			this.startLoading();
			
			ProfileService.getProfileData()
			.then(res => {
				if(res.success){
					for(var k in res.data) this.user[k]=res.data[k];
					this.orgUser = res.data;
				}
				this.stopLoading()
			})
			.catch(e => {
				console.log(e)
				this.$router.push('/login')
				this.stopLoading()
			})
		
		},
		validateEditEmail() {
			if(this.email == ''){
				this.errors.email = this.$t('user.emailCanNotBeEmpty');
				this.canUpdateEmail = false;
				return false;
			}else if(!this.validateEmail(this.email)){
				this.errors.email = this.$t('invalidEmailFormat');
				this.canUpdateEmail = false;
				return false;
			}
			this.errors.email = '';
			this.canUpdateEmail = true;
			return true;
		},
		updateEmail() {
			if(this.email == this.user.email){
				this.errors.email = this.$t('noChanges')
				this.editEmail = false;
				return;
			}
			this.startLoading()
			ProfileService.updateProfileData({unverifiedEmail: this.email})
			.then( res => {
				res = res.data;
				if(res.code == 200){
					this.editEmail = false;
					this.verifyEmail = true;
				}
				this.stopLoading();
			})
			.catch( err => {
				console.log('updateProfile', err)
				this.stopLoading();
			})
		},

		verifyUnverifiedEmail() {
			this.startLoading()
			ProfileService.sendEmailVerifyOTP()
			.then( res => {
				res = res.data;
				if(!res.success){
					console.log(res.message)
					this.$notify({
						title: this.$t('user.unableToVerifyEmail'),
						text: this.$t('pleaseTryAgainAfterSometime'),
						type: 'error'
					});
					return;
				}
				this.showOtp = true;
				this.stopLoading();
				this.$notify({
					title: this.$t('user.otpSentOnEmail'),
					text:this.$t('user.otpSentSuccessFully'),
					type: 'success'
				});
			})
			.catch(err => {
				console.log('email otp err', err)
				this.stopLoading();
			})
		},

		updateProfile() {
			const data = {};

			if(this.orgUser.firstName !== this.user.firstName){
				data.firstName = this.user.firstName;
			}

			if(this.orgUser.lastName !== this.user.lastName){
				data.lastName = this.user.lastName;
			}
			if(data && Object.keys(data).length === 0){
				this.$notify({
					title: this.$t('user.profileNotUpdated'),
					text:this.$t('nothingchanged'),
					type: 'error'
				});
				return;
			}

			this.startLoading()
			ProfileService.updateProfileData(data)
			.then( res => {
				res = res.data;
				if(res.code == 200){
					this.editEmail = false;
					this.verifyEmail = true;
					this.stopLoading();
					this.$notify({
						title: this.$t('user.profileUpdated'),
						text: this.$t('somethingWentWrong'),
						type: 'success'
					});
				}else{
					this.$notify({
						title:  this.$t('user.profileNotUpdated'),
						text: this.$t('somethingWentWrong'),
						type: 'error'
					});
				}
			})
			.catch( err => {
				console.log('updateProfile', err)
				this.stopLoading();
				this.$notify({
					title:  this.$t('user.profileNotUpdated'),
					text: this.$t('somethingWentWrong'),
					type: 'error'
				});
			})			
		}
	},
	mixins: [loading, generalMixin]
}

</script>

<style scoped lang="scss">
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>